import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import DOMPurify from 'dompurify';

const baseUrl = process.env.REACT_APP_API_URL ;

export const DoctorListCard = ({
  doctorName,
  doctorSpecialty,
  doctorSemat,
  doctorImage,
  codenezam,
  doctorAddress,
  DoctorID,
  buttonOnClick,
  buttonLabel,
}) => {
 
  return (
    <li className="card p-3 shadow rounded-3 mt-2">
      <div className="row text-lg-right text-center">
        <div className="col-lg-2 text-lg-left text-center align-self-center order-1 order-lg-1">
          <img
            src={`${baseUrl}Home/ShowImg?Filename=${doctorImage}`}
            style={{
              width: '150px',
              height: '150px',
              objectFit: 'cover', // حفظ نسبت ابعاد و پر کردن فضا
            }}
            className="border rounded-circle"
            alt="Doctor"
          />
        </div>
        <div className="col-lg-8 text-right order-2 order-lg-2">
          <h3 className="font-weight-bold" style={{ color: 'rgb(6,80,122)' }}>
            {doctorName}
          </h3>
          <div
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(doctorSpecialty) }}
              className="mt-2"
            />
          
          {doctorSemat ? (
            <div
              className="mt-2"
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(doctorSemat) }}
            />
          ) : null}
          <p className="mt-3">  {codenezam}</p>
          {/* <div className="d-flex flex-sm-row flex-column justify-content-lg-start justify-content-center mb-lg-0 mb-3">
            <div className="d-flex flex-row justify-content-center">
              <span>
                {doctorRate &&
                  Array(doctorRate)
                    .fill(null)
                    .map((_, index) => (
                      <FontAwesomeIcon
                        key={index}
                        icon={faStar}
                        className="text-warning"
                      />
                    ))}
              </span>
            </div>
          </div> */}
        </div>
        <div className="col-lg-2 d-flex flex-column justify-content-center order-3 order-lg-3">
          <button
            onClick={buttonOnClick}
            className="btn btn-primary IRANSans_Medium py-4 w-100"
          >
            {buttonLabel || 'نوبت بگیرید'}
          </button>
        </div>
      </div>
    </li>
  );
};